var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { CompletedStep, ProcessStep } from 'Components.Structure';
import { AsyncSelect, Button } from 'Components.Form';
import { debounce } from 'Utils';
import { CommissioningApi } from 'Api';
import { injectIntl, FormattedMessage } from 'Intl';
import { AuthService } from 'Services';
var ValidationMessage = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 14px;\n  margin: 10px 0;\n  font-weight: bold;\n  color: ", ";\n"], ["\n  font-size: 14px;\n  margin: 10px 0;\n  font-weight: bold;\n  color: ", ";\n"])), function (_a) {
    var isValid = _a.isValid;
    return (isValid ? 'black' : 'red');
});
var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var Select = styled(AsyncSelect)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var ValidateButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 200px;\n  height: 38px;\n  margin-left: 10px;\n"], ["\n  width: 200px;\n  height: 38px;\n  margin-left: 10px;\n"])));
var OrganisationLookupProcessStep = /** @class */ (function (_super) {
    __extends(OrganisationLookupProcessStep, _super);
    function OrganisationLookupProcessStep(props) {
        var _this = _super.call(this, props) || this;
        _this.commissioningApi = new CommissioningApi();
        _this.loadOptions = function () { return function (inputValue, callback) {
            if (inputValue == null || inputValue === '')
                return;
            _this.commissioningApi.lookupOrganisations({
                s: inputValue,
            }).then(function (result) {
                if (result.isSuccess && result.payload) {
                    if (result.payload.organisation != null) {
                        callback([{
                                label: result.payload.organisation.name,
                                value: result.payload.organisation.id,
                                fleet: result.payload.fleet,
                            }]);
                    }
                    else if (result.payload.organisations != null) {
                        callback(result.payload.organisations.map(function (r) { return ({
                            label: r.name,
                            value: r.id,
                            fleet: null,
                        }); }));
                    }
                    else {
                        callback([]);
                    }
                }
            });
        }; };
        _this.onValidateVehicle = function () { return __awaiter(_this, void 0, void 0, function () {
            var selectedOrganisation, vehicle, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedOrganisation = this.state.selectedOrganisation;
                        vehicle = this.props.vehicle;
                        if (selectedOrganisation == null || !(vehicle === null || vehicle === void 0 ? void 0 : vehicle.vrn))
                            return [2 /*return*/];
                        this.setState({ isValidating: true, vehicleValidated: null });
                        return [4 /*yield*/, this.commissioningApi.verifyVehicle({
                                organisationId: selectedOrganisation.value,
                                vrn: vehicle.vrn,
                                vin: vehicle.vin
                            })];
                    case 1:
                        result = _a.sent();
                        if (!result.payload) {
                            this.setState({ isValidating: false, vehicleValidated: false });
                            return [2 /*return*/];
                        }
                        this.setState({ isValidating: false, vehicleValidated: true });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            selectedOrganisation: null,
            confirmed: false,
            vehicleValidated: null,
            isValidating: false,
        };
        return _this;
    }
    OrganisationLookupProcessStep.prototype.componentDidMount = function () {
        var user = AuthService.getAccessTokenDetail();
        if ((user != null && user.organisation_id === '622f6533-00a2-473b-8fe1-8131065054cf') || !this.props.isNewVehicleCreated) {
            this.setConfirmed(true);
        }
    };
    OrganisationLookupProcessStep.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isNewVehicleCreated !== this.props.isNewVehicleCreated) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setConfirmed(!this.props.isNewVehicleCreated);
        }
    };
    OrganisationLookupProcessStep.prototype.setSelectedOrganisation = function (organisationType) {
        this.setState({
            selectedOrganisation: organisationType,
        });
    };
    OrganisationLookupProcessStep.prototype.setConfirmed = function (confirmed) {
        this.setState({
            confirmed: confirmed,
        });
    };
    OrganisationLookupProcessStep.prototype.renderOrganisationSelect = function () {
        var _this = this;
        var _a = this.props, baseId = _a.baseId, readonly = _a.readonly, organisation = _a.organisation, intl = _a.intl;
        var _b = this.state, vehicleValidated = _b.vehicleValidated, isValidating = _b.isValidating, selectedOrganisation = _b.selectedOrganisation;
        if (readonly && organisation) {
            return (React.createElement(CompletedStep, { title: organisation ? organisation.name : '' }));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Container, null,
                React.createElement(Select, { id: "".concat(baseId, "_organisation_select"), placeholder: intl.formatMessage('organisationLookup.selectPlaceholder'), isClearable: true, cacheOptions: true, defaultOptions: true, loadOptions: debounce(this.loadOptions(), 500), onChange: function (evt) {
                        _this.setSelectedOrganisation(evt);
                        _this.setState({ isValidating: false, vehicleValidated: null });
                    }, noOptionsMessage: function () { return intl.formatMessage('organisationLookup.noOrganisations'); } }),
                selectedOrganisation && vehicleValidated == null && (React.createElement(ValidateButton, { id: "".concat(baseId, "_validate-vehicle"), onClick: this.onValidateVehicle, primary: true }, isValidating
                    ? React.createElement(FormattedMessage, { id: 'organisationLookup.validatingVehicle' })
                    : React.createElement(FormattedMessage, { id: 'organisationLookup.validateVehicle' })))),
            vehicleValidated != null && (React.createElement(ValidationMessage, { isValid: vehicleValidated, id: "".concat(baseId, "_validation-message") }, vehicleValidated
                ? React.createElement(FormattedMessage, { id: 'organisationLookup.vehicleValidated' })
                : React.createElement(FormattedMessage, { id: 'errorCode.COM-05-001' })))));
    };
    OrganisationLookupProcessStep.prototype.render = function () {
        var _this = this;
        var _a = this.state, confirmed = _a.confirmed, selectedOrganisation = _a.selectedOrganisation, vehicleValidated = _a.vehicleValidated;
        var _b = this.props, label = _b.label, organisation = _b.organisation, baseId = _b.baseId, readonly = _b.readonly, intl = _b.intl, isNewVehicleCreated = _b.isNewVehicleCreated;
        var user = AuthService.getAccessTokenDetail();
        return (React.createElement(ProcessStep, { baseId: baseId, confirmed: confirmed, label: label, isEditable: isNewVehicleCreated && (user == null || user.organisation_id !== '622f6533-00a2-473b-8fe1-8131065054cf'), subtitle: readonly
                ? intl.formatMessage('organisationLookup.confirmDescription')
                : intl.formatMessage('organisationLookup.findDescription'), confirmDisabled: !readonly && (selectedOrganisation == null || !vehicleValidated), onEditStep: function () {
                _this.props.onEdit();
                _this.setConfirmed(!confirmed);
                _this.setState({ isValidating: false, vehicleValidated: null });
                _this.setSelectedOrganisation(null);
            }, onConfirm: function () {
                if (!readonly && selectedOrganisation == null || vehicleValidated == null)
                    return;
                _this.setConfirmed(!confirmed);
                _this.props.onConfirm(selectedOrganisation);
            }, confirmedContent: (React.createElement(React.Fragment, null, (organisation != null) && (React.createElement(CompletedStep, { title: organisation ? organisation.name : '' })))), activeContent: this.renderOrganisationSelect() }));
    };
    return OrganisationLookupProcessStep;
}(React.Component));
export default injectIntl(OrganisationLookupProcessStep);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
